module.exports = __webpack_public_path__ + "img/icon_rocket.2a0cd7e2.png";